// @ts-nocheck

import { isType } from '@/utils/is-type';
import { z } from 'zod';

export const checkIsUrl = isType(z.string().url());
